<template>
    <div v-if="!isError" :id="svgId"></div>
    <el-empty v-else class="empty" description="加载SVG失败"></el-empty>
</template>

<script>
import Vue from 'vue/dist/vue.esm.js'
import {
    matchingWeekToChinses
} from "@/assets/js/utils";
export default {
    name: "SvgTitle",
    props: {
        svgContainerId: {
            type: String,
            default: 'svgContent'
        },
        svgId: {
            type: String,
            default: 'svgTemplate'
        },
        //path为assets下静态文件，url是远程路径
        svgUrlType: {
            type: String,
            default: 'path'
        },
        svgUrl: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            isError: false,
            timeInterval: null,
            destoryFlag: false,
        }
    },
    computed: {},
    methods: {
        handleChange(val) {
            // console.log('handleChange---', val);
        },
        windowResizeEvent(callback) {
            window.onresize = function () {
                var target = this;
                if (target.resizeFlag) {
                    clearTimeout(target.resizeFlag);
                }

                target.resizeFlag = setTimeout(function () {
                    callback();
                    target.resizeFlag = null;
                }, 100);
            }
        },
        contentResize() {
            if (document.getElementById("svgMain")) {
                // console.log(" document.getElementById(svgContainerId).clientHeight==", document.getElementById(this.svgContainerId).clientHeight);
                // console.log("document.getElementById(svgContainerId).clientWidth==", document.getElementById(this.svgContainerId).clientWidth);
                document.getElementById("svgMain").style.width = document.getElementById(this.svgContainerId).clientWidth + 'px';
                document.getElementById("svgMain").style.height = document.getElementById(this.svgContainerId).clientHeight + 'px';
            }
        },
        getSvg() {
            const newUrl = this.svgUrl
            // console.log("getSvg---newUrl---", newUrl);
            if (this.destoryFlag) {
                return
            }
            if (!newUrl) {
                console.log("url为空，重新获取", this);
                setTimeout(() => {
                    this.getSvg()
                }, 500);
                return
            }
            const xhr = new XMLHttpRequest();
            try {
                if (this.svgUrlType === "path") {
                    xhr.open("GET", require('@/assets/' + newUrl.substr(9)), true);
                } else {
                    xhr.open("GET", newUrl, true);
                }
                xhr.send();
                xhr.addEventListener("load", () => {
                    // const resXML = xhr.responseXML  
                    const resXML = this.stringToXml(xhr.responseXML)
                    if (resXML) {
                        this.isError = false
                        const svgDom = resXML.documentElement.cloneNode(true); // 克隆节点
                        // console.log(svgDom, '---svgDom-->>>')
                        // 为 svg - dom 设置宽高边框样式
                        svgDom.style.width = document.getElementById(this.svgContainerId).clientWidth + 'px';
                        svgDom.style.height = document.getElementById(this.svgContainerId).clientHeight + 'px';
                        // this.contentResize()
                        // 为svg添加鼠标滚动缩放事件
                        svgDom.setAttribute("id", "svgMain");
                        //  获取缩放宽高限制 属性
                        let svgtag = svgDom
                        // console.log(svgtag, '---svgtag-->>>')
                        //  设置 id 属性
                        let gtag = [...svgDom.getElementsByTagName("g")];
                        gtag[0].setAttribute("id", "svgCanvas");
                        /* 将svgDom对象转换成vue的虚拟dom */
                        var oSerializer = new XMLSerializer();
                        var sXML = oSerializer.serializeToString(svgDom);
                        var Profile = Vue.extend({
                            template: `<div id="${this.svgId}"> ${sXML} </div>`
                        });
                        // 创建实例，并挂载到元素上
                        new Profile().$mount(`#${this.svgId}`);
                        this.$nextTick(function () {
                            this.getData()
                            //窗口自适应,解决svg黑边
                            this.windowResizeEvent(this.contentResize)
                        })
                    } else {
                        this.isError = true
                        console.log(resXML, "getSvg---resXML");
                    }
                });
            } catch (error) {
                console.log(error, "getSvg---error");
            }
        },
        stringToXml(xmlString) {
            let xmlDoc = null
            if (typeof xmlString == "string") {
                //FF
                if (document.implementation.createDocument) {
                    var parser = new DOMParser();
                    xmlDoc = parser.parseFromString(xmlString, "text/xml");
                } else if (window.ActiveXObject) {
                    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                    xmlDoc.async = false;
                    xmlDoc.loadXML(xmlString);
                }
            } else {
                xmlDoc = xmlString;
            }
            return xmlDoc;
        },
        getData() {
            const now = this.$moment()
            const day = now.format("DD")
            const month = now.format("MM")
            const year = now.format("yyyy")
            const weekday = matchingWeekToChinses(now.format("d"))
            const arr = [{ key: 'yearHome', value: year }, { key: 'monthHome', value: month }, { key: 'dayHome', value: day }, { key: 'weekHome', value: weekday }]
            arr.forEach(element => {
                const { key = "", value = "" } = element
                let node = document.getElementById(key);
                if (node?.children?.[0]?.innerHTML) {
                    node.children[0].innerHTML = value
                }
            });
            const newInterval = this.$moment().endOf('day').format('x') - new Date().getTime()
            this.timeInterval = setTimeout(() => {
                this.getData()
            }, newInterval); //每天0点刷新
        },
    },
    created() {
        this.getSvg();
    },
    mounted() {
        this.$bus.$on("getChangeMenuType", (data) => {
            this.$nextTick(function () {
                this.contentResize()
            })
        });
    },
    beforeDestroy() {
        if (this.timeInterval) {
            clearTimeout(this.timeInterval);
            this.timeInterval = null
        }
        window.removeEventListener("resize", this.testResize);
        this.destoryFlag = true
        this.$bus.$off("getChangeMenuType");
    }
}
</script> 

<style lang="scss" scoped></style>